import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { QUOTE_STATUS } from '../../styles/tokens';

export function QuoteStatusPill({ status, size = 'md' }) {
    const { t } = useTranslation();
    const s = QUOTE_STATUS[status] || QUOTE_STATUS.DRAFT;
    const small = size === 'sm';
    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, px: small ? 0.9 : 1.1, py: small ? 0.15 : 0.35, borderRadius: 999, bgcolor: s.bg, whiteSpace: 'nowrap' }}>
            <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: s.color }} />
            <Typography sx={{ fontSize: small ? 11.5 : 12.5, fontWeight: 700, color: s.color }}>{t(`quotes.status.${status}`)}</Typography>
        </Box>
    );
}
